import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  LogisticsInitialStore,
  PatchCoverageAreaDriversPayload,
} from "./types.store";
// eslint-disable-next-line import/no-cycle
import {
  handleGetWorkingAreaRequest,
  handleGetWorkingAreasRequest,
  handleUpdateWorkingAreaStatusRequest,
  handleUpdateWorkingAreaRequest,
  handleUpdateWorkingHourRequest,
  handleDeleteWorkingAreaRequest,
} from "./thunk.store";

const initialState: LogisticsInitialStore = {
  workingAreas: null,
  workingAreaDetails: {},
};

const LogisticsStore = createSlice({
  initialState,
  name: "logisticsData",
  reducers: {
    patchCoverageAreaDrivers: (
      state,
      action: PayloadAction<PatchCoverageAreaDriversPayload>,
    ) => {
      const coverageArea =
        state.workingAreaDetails[action.payload.coverageAreaId];
      if (coverageArea) {
        state.workingAreaDetails[action.payload.coverageAreaId] = {
          ...coverageArea,
          ...action.payload.patch,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(handleGetWorkingAreasRequest.fulfilled, (state, action) => {
      state.workingAreas = action.payload;
      state.workingAreaDetails = {};
    });
    builder.addCase(handleGetWorkingAreaRequest.fulfilled, (state, action) => {
      state.workingAreaDetails[action.payload.id] = action.payload;
    });
    builder.addCase(
      handleUpdateWorkingAreaStatusRequest.fulfilled,
      (state, action) => {
        const coverageArea = state.workingAreaDetails[action.payload.id];
        if (coverageArea) {
          coverageArea.enabled = action.payload.enabled;
        }
      },
    );
    builder.addCase(
      handleUpdateWorkingAreaRequest.fulfilled,
      (state, action) => {
        state.workingAreaDetails[action.payload.id] = action.payload;
        state.workingAreas =
          state.workingAreas?.map((workingArea) =>
            workingArea.id === action.payload.id
              ? { ...workingArea, name: action.payload.name }
              : workingArea,
          ) ?? null;
      },
    );
    builder.addCase(
      handleUpdateWorkingHourRequest.fulfilled,
      (state, action) => {
        const coverageArea =
          state.workingAreaDetails[action.payload.coverageAreaId];
        if (coverageArea) {
          coverageArea.openingHours = action.payload.openingHours;
          coverageArea.holidayOpeningHours =
            action.payload.holidayOpeningHours ?? [];
        }
      },
    );
    builder.addCase(
      handleDeleteWorkingAreaRequest.fulfilled,
      (state, action) => {
        state.workingAreas =
          state.workingAreas?.filter(
            (workingArea) => workingArea.id !== action.payload.id,
          ) || null;
        delete state.workingAreaDetails[action.payload.id];
      },
    );
  },
});

export const { patchCoverageAreaDrivers } = LogisticsStore.actions;

export default LogisticsStore.reducer;
